import { BaseDTO } from '../global/base.dto';
import { CollectiveAgreementRateListDTO } from '../collective-agreement-rate/collective-agreement-rate-list.dto';
import { UserListDTO } from '../user/user-list.dto';

export class CollectiveAgreementDTO extends BaseDTO {

    name: string;

    description: string;

    maxOvertimeHours: number;

    overtimeRange: number;

    overtimeLifetime: number;

    maxCompensationHours: number;

    compensationRange: number;

    compensationLifetime: number;

    maxFlexHours: number;

    flexRange: number;

    flexLifetime: number;

    maxFlexPerEvent: number;

    users: Array<UserListDTO>;

    collectiveAgreementRates: Array<CollectiveAgreementRateListDTO>;

}
